package com.upcominds.expedite.features.community

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.upcominds.expedite.data.communities.CommunitiesRepository
import com.upcominds.expedite.data.mobilelogs.logMobileError
import com.upcominds.expedite.model.Community
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch


data class CommunityUiState(
    val loading: Boolean = false,
    val error: String? = null,
    val myCommunities: List<Community> = emptyList(),
    val popularCommunities: List<Community> = emptyList(),
    val activeCommunityId: String? = null,
    val selectionLoading: Boolean = false
)

class CommunityViewModel(
    private val communitiesRepository: CommunitiesRepository
): ViewModel() {

    private val _uiState = MutableStateFlow(CommunityUiState())
    val uiState: StateFlow<CommunityUiState> = _uiState.asStateFlow()

    init {
        //loadCommunities()
    }

    fun loadCommunities() {
        if (_uiState.value.loading) return
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(loading = true, error = null)
            try {
                val context = communitiesRepository.getCommunityContext()
                val available = communitiesRepository.getAvailableCommunities()
                _uiState.value = _uiState.value.copy(
                    loading = false,
                    error = null,
                    myCommunities = context.communities,
                    popularCommunities = available,
                    activeCommunityId = context.activeCommunityId
                )
            } catch (e: Exception) {
                logMobileError("CommunityViewModel.loadCommunities", e)
                _uiState.value = _uiState.value.copy(
                    loading = false,
                    error = e.message,
                )
            }
        }
    }

    fun selectActiveCommunity(communityId: String) {
        if (communityId == _uiState.value.activeCommunityId || _uiState.value.selectionLoading) return
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(selectionLoading = true, error = null)
            try {
                val context = communitiesRepository.setActiveCommunity(communityId)
                _uiState.value = _uiState.value.copy(
                    selectionLoading = false,
                    myCommunities = context.communities,
                    activeCommunityId = context.activeCommunityId,
                    error = null
                )
            } catch (e: Exception) {
                logMobileError("CommunityViewModel.selectActiveCommunity", e)
                _uiState.value = _uiState.value.copy(
                    selectionLoading = false,
                    error = e.message
                )
            }
        }
    }

    fun joinCommunity(communityId: String) {
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(loading = true)
            try {
                // Perform the join. The repository returns the joined Community
                communitiesRepository.joinCommunity(communityId)

                // Reload the joined communities to ensure state is correct
                val context = communitiesRepository.getCommunityContext()

                _uiState.value = _uiState.value.copy(
                    loading = false,
                    myCommunities = context.communities,
                    activeCommunityId = context.activeCommunityId,
                )
            } catch (e: Exception) {
                logMobileError("CommunityViewModel.joinCommunity", e, "Failed to join community $communityId")
                _uiState.value = _uiState.value.copy(
                    loading = false,
                    error = e.message,
                )
            }
        }
    }

    // New: leave a community (repo must implement leaveCommunity)
    fun leaveCommunity(communityId: String) {
        viewModelScope.launch {

        }
    }

    // Helper to check membership quickly from current state
    fun isMember(communityId: String): Boolean {
        return _uiState.value.myCommunities.any { it.id == communityId }
    }
}
